





























import api from "@/api/api"
import { Component, Vue } from "vue-property-decorator"
import updateTdk from "@/utils/tdk"
@Component({
  name: "Novel",
  components: {
    Slide: () => import("./components/Slide.vue"),
    Hot: () => import("./components/Hot.vue"),
    Column: () => import("./components/Column.vue"),
    LoadMore: () => import("@/components/loadMore/loadMore.vue"),
    NoMoreData: () => import("@/components/noMoreData/noMore.vue"),
    LoadMoreBtn: () => import("@/components/LoadMoreBtn/LoadMoreBtn.vue")
  },
  tdk() {
    return this.$store.state.tdk
  }
})
export default class Novel extends Vue {
  get columns() {
    return this.$root.$tstore.modules.novel.getters.columns
  }

  fetchData() {
    return Promise.all([
      this.$root.$tstore.modules.novel.actions.FETCH_COLUMNS(),
      this.$root.$tstore.modules.tdk.actions.FETCH_TDK({
        type: "manual",
        _id_or_name: encodeURI("新奇页")
      })
    ]).finally(() => {
      updateTdk.call(this)
    })
  }

  // ssr hook
  serverPrefetch() {
    return this.fetchData()
  }

  async beforeMount() {
    if (!this.columns) {
      return this.fetchData()
    }
  }

  page = 1
  loading = false
  async handleLoadMore() {
    this.loading = true
    this.page++
    const res = await api.novel.columnList(this.page)
    const list = this.columns.list.concat(res.data)
    const total = parseInt(res.headers.total)

    this.$root.$tstore.modules.novel.mutations.SET_COLUMNS({
      list,
      total,
      finished: list.length >= total
    })
    this.loading = false
  }
}
